import { render, staticRenderFns } from "./ConsentLetterPageTable.vue?vue&type=template&id=58ce6263&scoped=true"
import script from "./ConsentLetterPageTable.vue?vue&type=script&lang=js"
export * from "./ConsentLetterPageTable.vue?vue&type=script&lang=js"
import style0 from "./ConsentLetterPageTable.vue?vue&type=style&index=0&id=58ce6263&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ce6263",
  null
  
)

export default component.exports